module.exports = __webpack_public_path__ + "static/media/chrome-logo.c365dfbe.svg";